/* PUBLISH TO HER BLOG (2026-11-03): the browser's half. It names the post and
   nothing else; api/admin.js `blog_publish` reads the post as stored, builds
   the pages (api/_lib/blogPage.js) and commits them to GitHub tevrawood/Blog,
   which Vercel puts live in about a minute. Admin only, there and here. */

export const BLOG_BASE = "https://blog.tevrawood.com";

/** Is this post on the blog already? Its address says so once published. */
export const isOnBlog = (n) => Boolean(n?.sentAt) && String(n?.canonicalUrl || "").startsWith(`${BLOG_BASE}/`);

/**
 * Returns { ok, url, sentAt, canonicalUrl, urlSlug, updated } or
 * { ok: false, error }. Never throws.
 */
export async function publishToBlog({ token, newsletterId }) {
  try {
    const res = await fetch("/api/admin", {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ action: "blog_publish", newsletterId }),
    });
    const r = await res.json().catch(() => ({}));
    if (r.ok) return r;
    return { ok: false, error: r.error || (res.status === 403 ? "Only you can publish to the blog." : "It didn't reach the blog. Try again in a moment.") };
  } catch {
    return { ok: false, error: "Couldn't reach Brill just then. Try again in a moment." };
  }
}
